import { profileConstants as pc } from 'srcReact/ProfilePage'
import { alertActions } from 'srcReact/Alert'
import { organizationActions } from 'srcReact/OrganizationPage'
import { userService, workplaceService } from 'srcReact/services'
import { commonActions } from 'srcReact/components'
import history from 'srcReact/helpers/history'
import { appConstantSettings } from 'srcReact/appConstantSettings'

export const profileActions = {
  //getEmailList,
  addEmail,
  //setDefaultEmail,
  //deleteEmail,
  // sendEmailValidationCode,
  //verifyEmailCode,
  resetEmailValidation,
  getInvites,
  respondToInvite
  //getMyWorkplaceInterests,
}

// function getEmailList(id) {
//   return (dispatch) => {
//     dispatch(request({ id }))

//     userService.getEmailList(id).then(
//       (response) => {
//         dispatch(success(response))
//       },
//       (error) => {
//         dispatch(failure(error))
//       }
//     )
//   }

//   function request(response) {
//     return { type: pc.GET_EMAIL_LIST_REQUEST, response }
//   }
//   function success(response) {
//     return { type: pc.GET_EMAIL_LIST_SUCCESS, response }
//   }
//   function failure(error) {
//     return { type: pc.GET_EMAIL_LIST_FAILURE, error }
//   }
// }

function addEmail(data) {
  return (dispatch) => {
    dispatch(request(data))

    userService.addEmail(data).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: pc.ADD_EMAIL_REQUEST, response }
  }
  function success(response) {
    return { type: pc.ADD_EMAIL_SUCCESS, response }
  }
  function failure(error) {
    return { type: pc.ADD_EMAIL_FAILURE, error }
  }
}

// function setDefaultEmail(email) {
//   return (dispatch) => {
//     dispatch(request(email))

//     userService.setDefaultEmail(email).then(
//       (response) => {
//         dispatch(success(response))
//       },
//       (error) => {
//         dispatch(failure(error, email))
//         dispatch(alertActions.error(error))
//       }
//     )
//   }

//   function request(email) {
//     return { type: pc.SET_DEFAULT_EMAIL_REQUEST, email }
//   }
//   function success(email) {
//     return { type: pc.SET_DEFAULT_EMAIL_SUCCESS, email }
//   }
//   function failure(error, email) {
//     return { type: pc.SET_DEFAULT_EMAIL_FAILURE, error, email }
//   }
// }

// function deleteEmail(email) {
//   return (dispatch) => {
//     dispatch(request({ email }))

//     userService.deleteEmail(email.id).then(
//       (response) => {
//         dispatch(success(email))
//       },
//       (error) => {
//         dispatch(failure(error, email))
//         dispatch(alertActions.error(error))
//       }
//     )
//   }

//   function request(email) {
//     return { type: pc.DELETE_EMAIL_REQUEST, email }
//   }
//   function success(email) {
//     return { type: pc.DELETE_EMAIL_SUCCESS, email }
//   }
//   function failure(error, email) {
//     return { type: pc.DELETE_EMAIL_FAILURE, error, email }
//   }
// }

// function sendEmailValidationCode(email) {
//   return (dispatch) => {
//     dispatch(request({ email }))

//     userService.sendValidationCode(email).then(
//       (response) => {
//         dispatch(success(response))
//       },
//       (error) => {
//         dispatch(alertActions.error(error))
//         dispatch(failure(error))
//       }
//     )
//   }

//   function request(response) {
//     return { type: pc.SEND_EMAIL_VALIDATION_CODE_REQUEST, response }
//   }
//   function success(response) {
//     return { type: pc.SEND_EMAIL_VALIDATION_CODE_SUCCESS, response }
//   }
//   function failure(error) {
//     return { type: pc.SEND_EMAIL_VALIDATION_CODE_FAILURE, error }
//   }
// }

// function verifyEmailCode(email, hashname, code) {
//   return (dispatch) => {
//     dispatch(request({ email, hashname, code }))

//     userService.verifyEmailCode(email, hashname, code).then(
//       (response) => {
//         dispatch(success(response))
//         history.push('/0/emails/settings')
//       },
//       (error) => {
//         dispatch(
//           alertActions.error(
//             error.hasOwnProperty('message') ? error.message : error
//           )
//         )
//         dispatch(failure(error.hasOwnProperty('error') ? error.error : error))
//       }
//     )
//   }

//   function request(response) {
//     return { type: pc.VERIFY_EMAIL_CODE_REQUEST, response }
//   }
//   function success(response) {
//     return { type: pc.VERIFY_EMAIL_CODE_SUCCESS, response }
//   }
//   function failure(error) {
//     return { type: pc.VERIFY_EMAIL_CODE_FAILURE, error }
//   }
// }

function resetEmailValidation() {
  return { type: pc.RESET_EMAIL_VALIDATION }
}

function getInvites(qty, offset = 0) {
  return (dispatch) => {
    dispatch(request({ qty, offset }))

    workplaceService.getInvites(qty, offset).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: pc.GET_INVITE_LIST_REQUEST, response }
  }
  function success(response) {
    return { type: pc.GET_INVITE_LIST_SUCCESS, response }
  }
  function failure(error) {
    return { type: pc.GET_INVITE_LIST_FAILURE, error }
  }
}

function respondToInvite(answer, invitationId) {
  return (dispatch) => {
    dispatch(request({ answer, invitationId }))

    workplaceService.respondToInvite(answer, invitationId).then(
      (response) => {
        dispatch(success({ invitationId, answer }))
        dispatch(organizationActions.getByUser(appConstantSettings.ORG_LIST_QTY))
        dispatch(commonActions.updateBannerData(response ? response.banner_data : null))
      },
      (error) => {
        dispatch(alertActions.error(error.hasOwnProperty('message') ? error.message : error))
        dispatch(failure({ invitationId }))
      }
    )
  }

  function request(response) {
    return { type: pc.RESPOND_TO_INVITE_REQUEST, response }
  }
  function success(response) {
    return { type: pc.RESPOND_TO_INVITE_SUCCESS, response }
  }
  function failure(error) {
    return { type: pc.RESPOND_TO_INVITE_FAILURE, error }
  }
}

// function getMyWorkplaceInterests(userId, workplaceId) {
//   return (dispatch) => {
//     dispatch(request({ userId, workplaceId }))

//     userService.getMemberInterests(userId, workplaceId).then(
//       (response) => {
//         dispatch(success(response))
//       },
//       (error) => {
//         dispatch(alertActions.error(error.toString()))
//         dispatch(failure(error))
//       }
//     )
//   }

//   function request(data) {
//     return { type: pc.GET_MY_WORKPLACE_INTERESTS_REQUEST, data }
//   }
//   function success(response) {
//     return { type: pc.GET_MY_WORKPLACE_INTERESTS_SUCCESS, response }
//   }
//   function failure(error) {
//     return { type: pc.GET_MY_WORKPLACE_INTERESTS_FAILURE, error }
//   }
// }
